<template>
  <component :is="value.meta.headingLevel || 'h1'" class="pigeondoc__heading">
    <span v-html="value.content"></span>
  </component>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'HeadingNodeDisplay',
  props: {
    value: PigeonDocNodeModel,
  },
};
</script>
